import {
    Form,
    FormInstance,
    Select  } from "antd";
  import { FC } from "react";
  import styled from "@emotion/styled";
import { useGetMasterBankType } from "hooks/useMasterData";

  interface TypeConfigFormProps {
    form: FormInstance;
  }

  const { Option } = Select;

  const TypeConfigForm: FC<TypeConfigFormProps> = ({
    form
  }) => {
    const { data: dataBankType } = useGetMasterBankType();

    const childrenBankType: React.ReactNode[] = [];
    childrenBankType.push(<Option key='' value=''>เลือกประเภทธนาคาร</Option>)

    dataBankType?.data?.map((item) => {
      return childrenBankType.push(
        <Option key={item.id} value={item.id}>
          {item.description}
        </Option>
      );
    });

    return (
      <FormWrapper>
        <FormItems
            labelAlign="left"
            label="ประเภทบัญชีธนาคาร"
            name="bank_type_id"
            rules={[{ required: true, message: "กรุณาเลือกประเภทบัญชีธนาคาร" }]}
          >
            <Select placeholder="กรุณาเลือกประเภทบัญชีธนาคาร" optionFilterProp="children">
              {childrenBankType}
            </Select>
        </FormItems>
      </FormWrapper>
    );
  };

  export default TypeConfigForm;

  const FormItems = styled(Form.Item)`
      margin-bottom: 10px;
      width:100%
  `
  const FormWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 20px 20px 2px 20px;
    background-color: #ffffffff;
  `;


const OptionContent = styled.div`
display: flex;
align-items: center;
`;

const ImageWrapper = styled.div`
margin-right: 8px;
width: 20px;  
height: 20px; 
img {
  margin-top: -10px;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
`;